import React from 'react';
import { useParams } from 'react-router-dom';
import ResponsesReport from './ResponsesReport';

// Standalone route wrapper around the shared ResponsesReport body. The primary
// entry point is the paths-area Responses page (AreaIndexPage); this stays as a
// direct per-path view.
function ResponsesReportPage() {
  const { lmSlug } = useParams();
  return (
    <div className="rr-wrap">
      <ResponsesReport slug={lmSlug} />
    </div>
  );
}

export default ResponsesReportPage;
